import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { MainLayout } from '../layouts'
import { SEO } from '../components'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

const getPrivacy = graphql`
  query Privacy {
    Privacy: contentfulInformation(title: { eq: "Privacy Policy" }) {
      title
      content {
        json
      }
    }
  }
`

const PrivacyPage = () => {
  const data = useStaticQuery(getPrivacy)
  return (
    <MainLayout>
      <SEO title="Privacy Policy" />
      <div className="container jsonSpace infoPage">
        <h2 className="title withLine">{data.Privacy.title}</h2>
        <div className="titleLine"></div>
        {documentToReactComponents(data.Privacy.content.json)}
      </div>
    </MainLayout>
  )
}

export default PrivacyPage
